import React, { Component } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

import { pushHistoryWithTitle, urls } from '../../utils/routing';
import { getUserRole, svgImageToBase64 } from '../../utils/functions';

import ButtonUserMenu from '../../containers/ButtonUserMenuWrapper/ButtonUserMenuWrapper';
import UserMenuWrapper from '../../containers/UserMenuWrapper/UserMenuWrapper';
import Search from '../Search/Search';
import Categories from '../../containers/CategoriesWrapper/CategoriesWrapper';

import './translations'; // translate nav text
import { NAV_LINK } from './translations';

import styles from './Nav.module.css';

export default class Nav extends Component {
    componentDidMount() {
        this.eventListenerScrollPage()
    }

    eventListenerScrollPage() {
        let lastScrollTop = 0;
        const navbar = document.getElementById('navigate');

        window.addEventListener('scroll', function() {
            let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

            if (currentScrollTop < lastScrollTop) {
                // Сscroll up
                navbar.classList.add(styles.base__top);
                navbar.classList.remove(styles.base__bottom); 
            } else if (currentScrollTop > lastScrollTop) {
                // scroll down
                navbar.classList.remove(styles.base__top);
                navbar.classList.add(styles.base__bottom);
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Обновляем последнее значение
        });
    }

    renderAdminLinks = () => {
        let userRole = getUserRole();
        const linkAdmSectClasses = classNames(styles.link, `js-mainmenu-item`, {
            [styles.isActive]: document.location.pathname === urls.adminSection,
        }); // ({isActive}) => (isActive ? `${styles.link} ${styles.isActive} ${styles.submenu_item__open}`: styles.link)
        const linkModerSectClasses = classNames(styles.link, `js-mainmenu-item`, {
            [styles.isActive]: document.location.pathname === urls.moderatorSection,
        });
        
        if (userRole === 'admin') {
            return (
                <li className={ linkAdmSectClasses }>
                    <NavLink exact="true" to={urls.adminSection} state={{ lastUrl: document.location.href }} >
                        {NAV_LINK.ADMIN_SECTION}
                    </NavLink>
                </li>
            )
        } else if (userRole === 'moderator') {
            return (
                <li className={ linkModerSectClasses }>
                    <NavLink exact="true" to={urls.moderatorSection} state={{ lastUrl: document.location.href }} >
                        {NAV_LINK.MODERATOR_SECTION}
                    </NavLink>
                </li>
            )
        } else {
            return null
        }
    }

    setClassListToBtn = (event) => {
        event.preventDefault();

        if ( document.getElementById("js-mainmenu-item").classList.contains(styles['submenu_item__open']) ) {
            document.getElementById("js-mainmenu-item").classList.remove(styles['submenu_item__open']);
            //document.getElementById("js-mainmenu-arrow").classList.remove(styles.opacity__up);
        } else {
            document.getElementById("js-mainmenu-item").classList.add(styles['submenu_item__open']);
            //document.getElementById("js-mainmenu-arrow").classList.add(styles.opacity__up);
        }
    }
    
    render() {
        const linkMainClasses = classNames(styles.link, { //  `js-mainmenu-item`,
            [styles.isActive]: document.location.pathname === urls.landing,
        }); // ({isActive}) => (isActive ? `${styles.link} ${styles.isActive} ${styles.submenu_item__open}`: styles.link)
        const linkNewsClasses = classNames(styles.link, {
            [styles.isActive]: document.location.pathname === urls.news,
        });
        const linkSubsClasses = classNames(styles.link, {
            [styles.isActive]: document.location.pathname === urls.subscriptions,
        });
        const linkModelClasses = classNames(styles.link, {
            [styles.isActive]: document.location.pathname === urls.modderSection,
        });

        const styleSubmenuArrow = document.createElement('style');
        styleSubmenuArrow.textContent = `
        .submenu_arrow {
            display: inline-block;
            vertical-align: middle;
            position: relative;
            top: -2px;
            right: 0;
            width: 28px;
            height: 28px;
            background: url(`+svgImageToBase64('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 7" width="8" height="5"><path fill="#3978ff" d="M0 5v2h1l5-4 5 4h1V5L6.1 0H6z"/></svg>')+`) no-repeat 50% 50%;
            background-size: auto;
            margin-left: 5px; 
            margin-right: -10px;
            transition: background-color .2s ease-out;
            padding: 0;
            cursor: pointer;
        }
        .submenu_arrow:hover {
            background-image: url(`+svgImageToBase64('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 7" width="8" height="5"><path fill="#aaaaab" d="M12 2V0h-1L6 4 1 0H0v2l5.9 5H6z"/></svg>')+`);
            background-color: var(--main-blue-color);
        }
        `;
        document.head.appendChild(styleSubmenuArrow);

        const navStyle = classNames(styles.base)

        return (
            <div className={navStyle} id="navigate">
                <ul className={styles.inner}>
                    {/* <a href="/" className={styles.logo} > </a> */}
                    <li className={styles.logo_t}>
                        <a href="/">
                            <span style={{ color: 'rgb(206, 212, 224)' }}></span>
                        </a>
                    </li>

                    <li className={ linkMainClasses } data-opened-class={styles['submenu_item__open']} id="js-mainmenu-item">
                        <a exact="true" href={urls.landing} state={{ lastUrl: document.location.href }} className={styles.submenu_link} >
                            {NAV_LINK.MAIN}
                            {/* <span className="submenu_arrow" onClick={this.setClassListToBtn} id ="js-mainmenu-arrow"></span> */}
                            <span className={classNames(styles.submenu_arrow)} onClick={this.setClassListToBtn} id ="js-mainmenu-arrow"></span>
                        </a>
                        <div className={styles.detail}>
                            <Categories 
                                history={this.props.history} 
                                location={this.props.location} 
                                navigate={this.props.navigate} 
                                params={this.props.params} />
                        </div>
                    </li>

                    <li className={ linkNewsClasses }>
                        <NavLink exact="true" to={urls.news} state={{ lastUrl: document.location.href }} >
                            {NAV_LINK.NEWS}
                        </NavLink>
                    </li>

                    <li className={ linkSubsClasses }>
                        <NavLink exact="true" to={urls.subscriptions} state={{ lastUrl: document.location.href }} >
                            {NAV_LINK.SUBSCRIPTIONS}
                        </NavLink>
                    </li>

                    <li className={ linkModelClasses }>
                        <NavLink exact="true" to={urls.modderSection} state={{ lastUrl: document.location.href }} >
                            {NAV_LINK.MODDER_SECTION}
                        </NavLink>
                    </li>

                    {this.renderAdminLinks()}

                    <li className={styles.search}>
                        <Search
                            value={this.props.searchTerm}
                            onSearchContolClick={(value) => {
                                value && pushHistoryWithTitle(this.props.history, value) // value && 
                            }}
                        />
                    </li>

                    <li><ButtonUserMenu /></li>

                    <li><UserMenuWrapper /></li>
                </ul>
            </div>
        )
    }
}


/*import React from 'react';
import { NavLink } from 'react-router-dom';

import { urls } from '../../utils/routing';

import ButtonUserMenu from '../../containers/ButtonUserMenuWrapper/ButtonUserMenuWrapper';
import UserMenuWrapper from '../../containers/UserMenuWrapper/UserMenuWrapper';
import './translations'; // translate nav text
import { NAV_LINK } from './translations';

import styles from './Nav.module.css';

export default function Nav() {
    
    renderLinks = () => {
        //
    }

    return (
        <div className={styles.base}>
            <nav className={styles.inner}>
                <a href="/" className={styles.logo} > </a>

                <NavLink exact="true" to={urls.landing} className={ ({isActive}) => (isActive ? `${styles.link} ${styles.isActive}`: styles.link) }>
                    {NAV_LINK.MAIN}
                </NavLink>

                <NavLink exact="true" to={urls.news} className={ ({isActive}) => (isActive ? `${styles.link} ${styles.isActive}` : styles.link) }>
                    {NAV_LINK.NEWS}
                </NavLink>

                <NavLink exact="true" to={urls.subscriptions} className={ ({isActive}) => (isActive ? `${styles.link} ${styles.isActive}` : styles.link) }>
                    {NAV_LINK.SUBSCRIPTIONS}
                </NavLink>

                <NavLink exact="true" to={urls.modderSection} className={ ({isActive}) => (isActive ? `${styles.link} ${styles.isActive}` : styles.link) }>
                    {NAV_LINK.MODDER_SECTION}
                </NavLink>

                <NavLink exact="true" to={urls.adminSection} className={ ({isActive}) => (isActive ? `${styles.link} ${styles.isActive}` : styles.link) }>
                    {NAV_LINK.ADMIN_SECTION}
                </NavLink>

                <ButtonUserMenu />

                <UserMenuWrapper />
            </nav>
        </div>
    )
}*/
